const DFM_REVIEW_ALERT_NOTIFY_FICTIV_HEADING =
    'Have you finished reviewing all of the DFM?'
const DFM_REVIEW_ALERT_EDIT_QUOTE_HEADING =
    'Your quote is being reviewed by Fictiv.'
const DFM_REVIEW_ALERT_NOTIFY_FICTIV_BODY =
    'Notify Fictiv so that one of our experts can review your DFM responses and provide you with instructions for next steps.'
const DFM_REVIEW_ALERT_EDIT_QUOTE_BODY = `You may continue making changes to your DFM responses while Fictiv is reviewing your quote.`

export const DFM_HELP_ARTICLE_TEXT =
    'Learn how to review and approve your DFM report'
export const DFM_HELP_ARTICLE_LINK =
    'https://help.fictiv.com/en/articles/6381212'

export const NOTIFY_FICTIV = 'Notify Fictiv'
export const FICTIV_NOTIFIED = 'Fictiv notified'

export const getAlertTitleText = (fictivNotified: boolean) => {
    return fictivNotified
        ? DFM_REVIEW_ALERT_EDIT_QUOTE_HEADING
        : DFM_REVIEW_ALERT_NOTIFY_FICTIV_HEADING
}

export const getAlertDescriptionText = (fictivNotified: boolean) => {
    return fictivNotified
        ? DFM_REVIEW_ALERT_EDIT_QUOTE_BODY
        : DFM_REVIEW_ALERT_NOTIFY_FICTIV_BODY
}
